import {
  type APIChannel,
  canalPrivado,
  ChannelType,
} from '@alternativamais/chat-core';

import type { NomeIcone } from '../componentes/Icone';

export function iconeDoCanal(canal: APIChannel): NomeIcone {
  switch (canal.type) {
    case ChannelType.GUILD_ANNOUNCEMENT:
      return 'anuncio';
    case ChannelType.GUILD_FORUM:
    case ChannelType.GUILD_MEDIA:
      return 'forum';
    case ChannelType.PUBLIC_THREAD:
    case ChannelType.PRIVATE_THREAD:
    case ChannelType.ANNOUNCEMENT_THREAD:
      return 'thread';
    case ChannelType.GUILD_VOICE:
    case ChannelType.GUILD_STAGE_VOICE:
      return 'voz';
    default:
      return canalPrivado(canal) ? 'cadeado' : 'hash';
  }
}
